import { useState } from 'react';
import { Button } from '../../components/ui/button';
import { Textarea } from '../../components/ui/textarea';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Copy, ArrowRightLeft } from 'lucide-react';
import { toast } from 'sonner';

const UrlEncoderTool = () => {
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');
  const [mode, setMode] = useState('encode');

  const encode = () => {
    try {
      const encoded = encodeURIComponent(input);
      setOutput(encoded);
      toast.success('URL encoded!');
    } catch (e) {
      toast.error('Failed to encode');
    }
  };

  const decode = () => {
    try {
      const decoded = decodeURIComponent(input);
      setOutput(decoded);
      toast.success('URL decoded!');
    } catch (e) {
      toast.error('Invalid URL encoded string');
    }
  };

  const copyOutput = () => {
    if (output) {
      navigator.clipboard.writeText(output);
      toast.success('Copied!');
    }
  };

  return (
    <div className="space-y-4" data-testid="url-encoder-tool">
      <div className="flex justify-between items-center">
        <h3 className="font-semibold">URL Encoder/Decoder</h3>
      </div>

      <Tabs value={mode} onValueChange={setMode}>
        <TabsList className="w-full">
          <TabsTrigger value="encode" className="flex-1">Encode</TabsTrigger>
          <TabsTrigger value="decode" className="flex-1">Decode</TabsTrigger>
        </TabsList>
      </Tabs>

      <Textarea
        placeholder={mode === 'encode' ? 'Enter URL or text to encode...' : 'Enter encoded URL to decode...'}
        value={input}
        onChange={(e) => setInput(e.target.value)}
        className="min-h-[120px] bg-background/50 font-mono text-sm"
        data-testid="input"
      />

      <Button onClick={mode === 'encode' ? encode : decode} className="w-full" data-testid="convert-btn">
        {mode === 'encode' ? 'Encode URL' : 'Decode URL'}
      </Button>

      {output && (
        <div className="space-y-2">
          <div className="flex justify-between items-center">
            <span className="text-sm text-muted-foreground">Output</span>
            <Button variant="ghost" size="sm" onClick={copyOutput}>
              <Copy className="w-4 h-4 mr-1" /> Copy
            </Button>
          </div>
          <Textarea
            value={output}
            readOnly
            className="min-h-[120px] bg-background/50 font-mono text-sm"
            data-testid="output"
          />
        </div>
      )}
    </div>
  );
};

export default UrlEncoderTool;
